<template>
<div class="my-3">
  
    <div class="">     
        <p class="error--text text-subtitle-2  ">{{errors.message}} !</p>
    </div>
</div>
</template>

<script>
export default{
    props:["errors"]
}
</script>

<style>
</style>